var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX4Um(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 100 100",
    viewBox: "8.5 8.5 83 83",
    id: "x",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M69.7,8.7H30.4c-11.7,0-21.3,9.5-21.3,21.3v41.2c0,11.7,9.5,21.3,21.3,21.3h39.4c11.7,0,21.3-9.5,21.3-21.3V29.9 C91,18.2,81.5,8.7,69.7,8.7z M76.8,78.3l-15.4,0c-0.1,0-0.2,0-0.2-0.1L46.8,57.3c0,0-0.1,0-0.1,0C40.9,64,35.2,70.6,29.6,77.1 c-0.3,0.4-0.7,0.7-1,1c-0.1,0.1-0.2,0.1-0.3,0.1l-4.2,0c-0.1,0-0.2,0-0.1-0.1l20.5-23.8c0.1-0.1,0.1-0.2,0-0.3L24.1,24.3 c0,0,0-0.1,0-0.1h15.5c0.1,0,0.1,0,0.2,0.1L53.4,44c0,0,0,0,0.1,0l16.9-19.7c0.1-0.1,0.2-0.1,0.3-0.1l4.2,0c0.2,0,0.2,0.1,0.1,0.2 L55.6,46.9c-0.1,0.1-0.1,0.2,0,0.3l21.3,31C76.9,78.2,76.9,78.3,76.8,78.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8,27.8C37.8,27.8,37.8,27.8,37.8,27.8l-6.7,0c-0.1,0-0.1,0.1-0.1,0.2l32.2,46.7c0,0,0,0,0.1,0h6.6 c0.1,0,0.1-0.1,0.1-0.2L37.8,27.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX4Um);
export default __webpack_public_path__ + "static/media/x4um.a78b4bcab0eaaa09e44235abdc38676a.svg";
export { ForwardRef as ReactComponent };